<template>
    <v-container fluid class="pa-0 background-color-toolbar" >
        <v-overlay color="#106c68" z-index="12" style="left: -57px;">
            <span class="loader"></span>
        </v-overlay>
    </v-container>
</template>
<script>
export default {
    props: [
    'shared_token',
    'biz_id'
    ],
    data: () => ({
        isDev: false,
        raDetail: {},
        aboutUser: {},
        OdPriority: false,
        loadingState: false,
        windowSize: { x: 0 },
    }),
    mounted () {
        if (this.shared_token) this.getToken()
    },
    methods: {
        async getToken(){
            try {
                this.loadingState = true
                var url = '/citizen/api/v1/user_login_sharedtoken'
                var {data} = await this.axios.post(this.$api_url + url,{
                    shared_token: this.shared_token
                })
                this.$apiConfig.setToken(data.data[0].access_token)
                sessionStorage.setItem('access_token', `${data.data[0].access_token}`)
                sessionStorage.setItem('refresh_token', `${data.data[0].refresh_token}`)
                // if(!this.biz_id){ // TO DO
                if (data.status && Object.keys(data.data).length) {
                    this.$store.commit('setAccessToken', data.data[0].access_token)
                    this.$apiConfig.setToken(data.data[0].access_token)
                    this.getUserRa(data.data[0].access_token)
                } else {
                    this.alert('กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่', 'Error', 'error')
                }
                // } else {}
            }catch (error) {
                console.log(error);
                sessionStorage.clear()
                this.$router.push({ 'path': '/login'})
                if (error.response.data.message === 'shared token is expire  ') {
                    this.alert('Login Shared Token Session Expired', 'Error', 'error')
                } else {
                    this.alert('กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่', 'Error', 'error')
                }
            }finally{
                this.loadingState = false
            }
        },
        async getUserRa(access_token) {
            if (!access_token) {
                this.loadingState = false
                return
            }
            try {
                const { data } = await this.axios.get(`${this.$api_url}/citizen/api/v1/user_ra`)
                if (data.status && Object.keys(data.data).length) {
                    this.$store.commit('setRaDetail', data.data)
                    this.$router.push({ path: '/selected_business'})
                } else {
                    this.alert('กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่', 'Error', 'error')
                }
            } catch (error) {
                console.log(error);
                if (error.response.data.message === 'token expired') {
                    this.alert('Session Expired', 'Error', 'error')
                } else {
                    this.alert('กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่', 'Error', 'error')
                }
            } finally {
                this.loading = false
            }
        },
        shakeErrorText(errorText = '') {
            this.alertText = errorText
            document.getElementById("error").classList.add("shake");
            setTimeout(() => {
                document.getElementById("error").classList.remove("shake");
            }, 1000);
        },
        alert(title = '', text = 'Error', icon = 'error') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text:  text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        }
    },
}
</script>